const SITE_ORIGINS = {
  choice: "https://charva-travel.com",
  global: "https://global.charva-travel.com",
  umrah: "https://umra.charva-travel.com",
  admin: "https://admin.charva-travel.com"
};
const DEV_SITE_ORIGINS = {
  choice: "http://localhost:5180",
  global: "http://localhost:5181",
  umrah: "http://localhost:5182",
  admin: "http://localhost:5183"
};
function siteOrigin(site, prod, override) {
  return override ?? (prod ? SITE_ORIGINS[site] : DEV_SITE_ORIGINS[site]);
}

export { DEV_SITE_ORIGINS, SITE_ORIGINS, siteOrigin };
//# sourceMappingURL=sites.js.map
//# sourceMappingURL=sites.js.map